export const text_maxDisplayed = 140
